import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styles: [
  ]
})
export class ErrorComponent implements OnInit {

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
    // this.temp();
  }

  temp() {
  }
}
